import { apiJson } from "../utils/api.js";
import { handleApiError } from "../utils/errorHandler.js";

export const listIntegrations = async () => {
    try {
        const response = await apiJson.get("/kms/integrations");
        return response.data;
    } catch (error) {
        handleApiError(error, { defaultMessage: "Failed to load integrations" });
        throw error;
    }
};

export const listProductDishes = async (configId) => {
    try {
        const response = await apiJson.get(`/kms/integrations/${configId}/product-dishes`);
        return response.data;
    } catch (error) {
        handleApiError(error, { defaultMessage: "Failed to load product mappings" });
        throw error;
    }
};

export const upsertProductDish = async (configId, payload) => {
    try {
        const response = await apiJson.put(`/kms/integrations/${configId}/product-dishes`, payload);
        return response.data;
    } catch (error) {
        handleApiError(error, { defaultMessage: "Failed to save product mapping" });
        throw error;
    }
};

export const deleteProductDish = async (configId, externalProductId) => {
    try {
        await apiJson.delete(
            `/kms/integrations/${configId}/product-dishes/${encodeURIComponent(externalProductId)}`
        );
    } catch (error) {
        handleApiError(error, { defaultMessage: "Failed to delete product mapping" });
        throw error;
    }
};
